
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Loader2 } from "lucide-react";
import { ErrorState, ErrorStateProps } from "@/components/ui/error-state";
import { cn } from "@/lib/utils";

interface LoadingErrorStateProps extends ErrorStateProps {
  isLoading?: boolean;
  loadingText?: string;
  children?: React.ReactNode;
  className?: string;
}

export function LoadingErrorState({
  isLoading = false,
  loadingText = "Loading...",
  error,
  onRetry,
  title,
  description,
  children,
  className,
  variant,
}: LoadingErrorStateProps) {
  if (isLoading) {
    return (
      <Card className={cn("w-full", className)}>
        <CardContent className="flex flex-col items-center justify-center py-8">
          <Loader2 className="h-8 w-8 text-muted-foreground animate-spin mb-4" />
          <p className="text-sm text-muted-foreground">{loadingText}</p>
        </CardContent>
      </Card>
    );
  }
  
  if (error) {
    return (
      <ErrorState
        title={title}
        description={description}
        error={error}
        onRetry={onRetry}
        className={className}
        variant={variant}
      />
    );
  }
  
  return <>{children}</>;
}
